import {
  Box,
  Button,
  InputBase,
  TableCell,
  TableRow,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import styled from "styled-components";
import CustomTable from "../../components/common-components/CustomTable";
import { ArrowRightCircleIcon } from "../../assets/Icon/ArrowIcon";

import { useAppDispatch } from "../../stores/store";
import { useSelector } from "react-redux";

import CommonPagination from "../../components/common-components/CommonPagination";

import { useNavigate } from "react-router-dom";
import CustomButton from "../../components/common-components/CustomButton";
import { getTaxFilingData } from "../../stores/taxfiling";

const btnStatus: Record<
  number,
  { label: string; bgColor: string; textColor: string }
> = {
  0: { label: "Pending", bgColor: "#FFF5DB", textColor: "#E7AB12" },
  2: { label: "Submitted", bgColor: "#EAF1FA", textColor: "#2977CC" },
};
const TaxFilingOrder = () => {
  const dispatch = useAppDispatch();
  const {
    data: agentList,
    status,
    error,
  } = useSelector((state: any) => state.incorporation);
  const { userId } = useSelector((store: any) => store.auth);
  const [page, setPage] = useState(1);
  const [searchQuery, setSearchQuery] = useState<any>("");
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(10);
  const [debouncedSearch, setDebouncedSearch] = useState<string>("");
  const navigate = useNavigate();
  const { taxfillingOrderList, total_records } = useSelector(
    (state: any) => state.taxfiling,
  );
  const fetchListOrder = taxfillingOrderList?.tax_filing_files_list;

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(searchQuery);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchQuery]);

  useEffect(() => {
    fetchList();
  }, []);

  const fetchList = async () => {
    const payload = {
      offset: 0,
      limit: 10,
    };
    try {
      const res = await dispatch<any>(getTaxFilingData(payload));
      if (!res?.payload?.tax_filing_files_list?.length) {
        navigate("/tools/tax-filing");
        return;
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handlePageChange = (newPage: number) => {
    setPage(newPage);
    setCurrentPage(newPage);
  };

  const fetchListOrderPagination = () => {
    const offset = (page - 1) * limit;
    const payload = {
      offset: offset,
      limit: limit,
    };
    dispatch<any>(getTaxFilingData(payload));
  };
  useEffect(() => {
    fetchListOrderPagination();
  }, [page, limit]);

  return (
    <>
      <StyledBox sx={{ paddingY: "16px" }}>
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",

            gap: "20px",
            padding: "20px",
            "@media (min-width: 600px)": {
              flexDirection: "row",
              justifyContent: "space-between",
              alignItems: "center",
            },
          }}
        >
          <Title>Tax Filing Applications</Title>

          <CustomButton
            btnTitle={"Tax Filing"}
            minwidth="191px"
            type="button"
            loading={false}
            handleClick={() =>
              navigate("/tools/tax-filing", { state: { fromButton: true } })
            }
          />
        </Box>

        <CustomTable
          headings={[
            "ORDER ID",
            "COMPANY",
            "AMOUNT",
            "TYPE",
            "STATUS",
            "ACTION",
          ]}
        >
          {fetchListOrder?.map((item: any, index: number) => (
            <TableRow>
              <TableCell
                sx={{
                  width: "15%",
                }}
              >
                <Typography>{item?.order_item_id || "-"}</Typography>
              </TableCell>
              <TableCell
                sx={{
                  width: "40%",
                }}
              >
                <Typography>{item?.product_name || "-"}</Typography>
              </TableCell>
              <TableCell
                sx={{
                  width: "20%",
                }}
              >
                <Typography>${item?.amount || "-"}</Typography>
              </TableCell>
              <TableCell
                sx={{
                  width: "20%",
                }}
              >
                <Typography>{item?.filling_type || "-"}</Typography>
              </TableCell>
              <TableCell
                sx={{
                  width: "20%",
                }}
              >
                <Box
                  sx={{
                    minWidth: "113px",
                    width: "auto",

                    textAlign: "center",
                    display: "inline-block",
                    padding: "9px",
                    // paddingx: "9px",
                    borderRadius: "6px",
                    fonsize: "12px",
                    fontWeight: "600",

                    backgroundColor:
                      btnStatus[item?.step === 2 ? 2 : 0]?.bgColor || "#ccc",
                    color:
                      btnStatus[item?.step === 2 ? 2 : 0]?.textColor || "#000",
                    whiteSpace: "nowrap",
                    cursor: "pointer",
                  }}
                >
                  {item?.step === 2 ? "Submitted" : "Pending"}
                </Box>
              </TableCell>

              <TableCell
                sx={{
                  width: "15%",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: 1,
                  }}
                >
                  {item?.id && (
                    <Box
                      onClick={() => {
                        if (item?.payment_status === "pending") {
                          navigate("/tools/tax-filing");
                          return;
                        }
                        if (item?.step === 2) {
                          navigate(
                            `/tools/tax-filing/tax-detail/${item?.id}/${item.order_item_id}`,
                          );
                        } else if (item?.step === 0) {
                          if (
                            item?.filling_type === "llc" &&
                            item?.have_multimembers
                          ) {
                            navigate(
                              `/tools/tax-filing/multimember/${item?.id}`,
                            );
                          } else if (item?.filling_type === "c-corp") {
                            navigate(
                              `/tools/tax-filing/corp-member/${item?.id}`,
                            );
                          } else {
                            navigate(
                              `/tools/tax-filing/single-member/${item?.id}`,
                            );
                          }
                        } else if (item?.step === 1) {
                          if (
                            item?.filling_type === "llc" &&
                            item?.have_multimembers
                          ) {
                            navigate(
                              `/tools/tax-filing/multimember-review/${item?.id}`,
                            );
                          } else if (item?.filling_type === "c-corp") {
                            navigate(
                              `/tools/tax-filing/review-ccrop/${item?.id}`,
                            );
                          } else {
                            navigate(`/tools/tax-filing/review/${item?.id}`);
                          }
                        }
                      }}
                      style={{ cursor: "pointer" }}
                    >
                      <ArrowRightCircleIcon />
                    </Box>
                  )}
                </Box>
              </TableCell>
            </TableRow>
          ))}
        </CustomTable>
        {/* Pagination */}
        {fetchListOrder &&
          total_records &&
          Math.ceil(total_records / limit) > 1 && (
            <Box sx={{ display: "flex", justifyContent: "end", mt: 3 }}>
              <CommonPagination
                currentPage={page}
                totalPages={Math.ceil(total_records / limit)}
                onPageChange={handlePageChange}
              />
            </Box>
          )}
      </StyledBox>
      {/* // ) : (
        //   <NoOrdersFound
        //     title="No LLC + EIN Applications Found"
        //     breakWords={["your"]}
        //     subTitle="It looks like no LLC + EIN applications have been submitted yet. Start your application today to set up your business seamlessly."
        //   />
        // )}
      // </> */}
    </>
  );
};

export default TaxFilingOrder;

const StyledBox = styled(Box)({
  background: "#ffffff",
  boxShadow: "0px 2px 40px 0px #DDE3EA33",
  borderRadius: "10px",
  // padding: "16px",
  margin: "16px",
});

const Container = styled(Box)({
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  padding: "20px",
});

const Title = styled(Typography)({
  color: "#01060B !important",
  fontSize: "20px !important",
  fontWeight: "600 !important",
});

const SearchContainer = styled(Box)({
  display: "flex",
  gap: "10px",
  alignItems: "center",
});

const SearchWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  background: "#F6F9FD",
  color: "#6B6B6B",
  borderRadius: "8px",
  padding: "5px 10px",
  "&:hover": {
    background: "#F6F9FD",
  },
});

const StyledButton = styled(Button)({
  width: "120px !important",
  whiteSpace: "nowrap",
  borderRadius: "6px !important",
  height: "40px !important",
});

const StyledInputBase = styled(InputBase)({
  minWidth: "300px",
  padding: "3px",
});
